import type { PageRef } from '@wix/editor-platform-sdk-types'
import {
  findPageRefByPageRole,
  getCollection,
  parseUrlPattern,
  type AppApi,
} from '@wix/wix-data-client-common'
import type {
  EditorSDK,
  RouterConfig,
} from '@wix/wix-data-client-common-standalone'
import { intersection } from 'lodash'

const getPageRefs = async (
  editorSdkProxy: EditorSDK,
  collectionId: string,
  generatedSlugFields: string[],
) => {
  const routers = await editorSdkProxy.routers.getAll<RouterConfig>()

  const pageRefs: PageRef[] = []

  for (const router of routers) {
    const patterns = Object.entries(router.config.patterns)
    for (const [pattern, patternDef] of patterns) {
      const routeCollection = getCollection(patternDef)
      const { fields } = parseUrlPattern(pattern)
      const containsGeneratedField =
        intersection(fields, generatedSlugFields).length > 0

      if (routeCollection === collectionId && containsGeneratedField) {
        const pageRef = findPageRefByPageRole(router, patternDef.pageRole)

        if (pageRef) {
          pageRefs.push(pageRef)
        }
      }
    }
  }

  return pageRefs
}

export const refreshRoutersForNewSlugs = async ({
  editorSdkProxy,
  appApi,
  collectionId,
  fields,
}: {
  editorSdkProxy: EditorSDK
  collectionId: string
  fields: string[]
  appApi: AppApi
}): Promise<void> => {
  const pageRefs = await getPageRefs(editorSdkProxy, collectionId, fields)

  if (pageRefs.length > 0) {
    appApi.emit('slugValuesGenerated', pageRefs)
    await editorSdkProxy.editor.routers.refresh()
  }
}
